import React from "react";
import { useFormContext } from "react-hook-form";
import { Form } from "@sscs/ui";
import { SAMLProviderConfigurationFormFields } from "../../types";
import FormPanel from "../FormPanel/FormPanel";

const SamlProviderConfiguration = (): React.JSX.Element => {
  const {
    formState: { errors },
  } = useFormContext<SAMLProviderConfigurationFormFields>();

  return (
    <FormPanel
      title="Provider configuration"
      byline="These values will be defined in the admin dashboard of your SSO identity provider"
    >
      <Form.TextField
        label="Metadata URL"
        isRequired
        name="metadata_url"
        id="metadata_url"
        errors={errors}
        helperText="URL of your SAML provider metadata endpoint"
      />
    </FormPanel>
  );
};

export default SamlProviderConfiguration;
